import "./DesktopFaqHero.css";
import { useLang } from "../../../../i18n/LangContext";
import questionImg from "../../../../assets/desktopFaq/hero/question.png";

export default function DesktopFaqHero({
  id = "faq-hero",
  imageSrc = questionImg,
  onGetStarted = () => {},
  onContact = () => {},
}) {
  const { t } = useLang();
  const data = t?.faqHero;
  if (!data) return null;

  return (
    <section id={id} className="faq-hero-root faq-hero-desktop" aria-label="FAQ introduction">
      <div className="faq-hero-wrap">
        <div className="faq-hero-left">
          <p className="faq-hero-eyebrow">{data.eyebrow}</p>
          <h1 className="faq-hero-title">
            {data.titleLine1}<br />{data.titleLine2}
          </h1>
          <p className="faq-hero-desc">{data.desc}</p>

          {/* <div className="faq-hero-cta">
            <button className="faq-hero-btn" onClick={onGetStarted}>
              <span>GET STARTED</span>
            </button>
            <button className="faq-hero-btn" onClick={onContact}>
              <span>CONTACT</span>
            </button>
          </div> */}
        </div>

        <div className="faq-hero-right">
          <img src={imageSrc} alt={data.imageAlt} loading="lazy" />
        </div>
      </div>
    </section>
  );
}
